/* eslint-disable new-cap */
/* eslint-disable camelcase */
import Phaser from 'phaser';
import { Images, Tweens } from '@abcya/abcya_phaser';
import AudioPlayer from '../library/AudioPlayer';

export default class InstructionsBox extends Phaser.GameObjects.Container {
  constructor(game, text, onClosed, secondText = null) {
    super(game);
    this.game = game;
    this.onClosed = onClosed;

    this.visible = false;

    this.overlay = Images.addImage(0, 0, 'pauseOverlay', this.scene);

    this.overlay.setOrigin(0);
    this.overlay.tint = 0x00000;
    this.overlay.inputEnabled = false;
    this.overlay.setInteractive();

    this.background = Images.addImage(0, 0, 'instructionsBackground', this);
    this.background.setOrigin(.5);

    if (secondText !== null) {
      const titleText = this.createText().setOrigin(0.5, 1);
      titleText.text = text;
      const descriptionText = this.createText().setOrigin(0.5, 0);
      descriptionText.text = secondText;
      descriptionText.y = titleText.y + 26;
      descriptionText.tint = 0xffff28;
    }
    else {
      const instructionText = this.createText();
      instructionText.text = text;
    }

    this.playButton = Images.addImage(0, 85,'plainPlayButton', this);
    this.playButton.setOrigin(.5);
    this.playButton.setScale(.25);
    this.playButton.setInteractive();
    this.playButton.once('pointerdown', () => {this.eh_PlayButton_Pressed();});

    this.flames = [];
    this.flames.push(Images.addImage(83, 270, 'instructionsFlame', this));
    this.flames.push(Images.addImage(-83, 270, 'instructionsFlame', this));
    for (let i = 0; i < this.flames.length; i++) {
      this.flames[i].setOrigin(.5, 0);
      this.flames[i].setScale(.5);
      this.add(this.flames[i]);
    }

    this.counter = 0;
    this.step = Math.PI * 2 / 360;
    this.x = this.scene.scale.width * .5;
    this.y = this.scene.scale.height * .5 - 70;

    this.randomness = 0;
    this.canFlicker = false;
    this.scene.time.addEvent({ delay: 50, loop: true, callback: () => {this.flickerFlame();} });
  }

  createText() {
    const text = this.scene.add.bitmapText(0, -50, 'Nasalization', '', 30);
    text.setOrigin(.5);
    text.setCenterAlign();
    text.tint = 0x56fe73;
    text.setMaxWidth(330);

    this.add(text);

    return text;
  }

  eh_PlayButton_Pressed() {
    this.canFlicker = false;
    this.playButton.disableInteractive();

    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.CLICK);
    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.ROCKET_BLAST_OFF);

    this.overlay.disableInteractive();
    Tweens.addTween(this, 2000, { y: -this.scene.scale.height - this.background.height }, Phaser.Math.Easing.Circular.In);
    Tweens.addTween(this.overlay, 500, { alpha: 0 }, Phaser.Math.Easing.None);

    for (let i = 0; i < this.flames.length; i++) {
      Tweens.addTween(this.flames[i], 2000, { scaleY: 1.5 }, Phaser.Math.Easing.Circular.In);
    }

    if (this.onClosed) this.onClosed();
  }

  Update() {
    const tStep = Math.sin(this.counter);
    this.y = tStep * .15 + this.y;
    this.counter += this.step;

    if (!this.canFlicker) return;
    for (let i = 0; i < this.flames.length; i++) {
      this.flames[i].scaleY = (-(tStep + .2) * .09 + this.flames[i].scaleX) + this.randomness;
    }
  }

  flickerFlame() {
    this.randomness = Math.random() * .02;
  }

  Display() {
    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.ROCKET_BLAST_OFF);
    for (let i = 0; i < this.flames.length; i++) {
      this.flames[i].scaleY = 1.5;
      Tweens.addTween(this.flames[i], 2000, { scaleY: .5 }, Phaser.Math.Easing.Circular.Out, () => {this.canFlicker = true;});

    }
    this.overlay.setInteractive();
    Tweens.addTween(this, 2000, { y: { start: this.scene.scale.height + this.background.height, to: this.y } }, Phaser.Math.Easing.Circular.Out, () => {
      // this.playButton.setInteractive();
      // this.bringToTop(this.playButton);
    }).on('start', () => {
      this.visible = true;
    });
  }
}